export const API_UI_CONFIG_BASE_URL = '/common/ui-config';
